export const COMMON = {
  ACCESS_TOKEN: "rtrtAccessTokan",
  ERROR_MESSAGE: {
    GATEWAY_ERROR_MESSAGE: "Gateway is Down. Please try again later.",
  },
  SHOW_SNACKBAR: "SHOW_SNACKBAR",
  HIDE_SNACKBAR: "HIDE_SNACKBAR",
  TOKEN_EXPIRED_MESSAGE: "Fetching access token please wait.",
  SNACKBAR_SEVERITY: {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info",
  },
  ADMIN_TAB: { MEETINGS: "meetings", INTERVENTION_LABEL: "intervention_label", ACRONYMS: "acronyms", USER_MANAGEMENT: "user_management" },
  USER: { DETAILS: "details", ROLE_PERMISSION: "role_permission" },
  USER_BE_KEYS: { DETAILS: "userDetails", ROLE_PERMISSION: "role_permission" },
  USER_DETAILS_LS_KEY: {
    DETAILS: "user_details",
    ROLE_PERMISSION: "role_permission",
  },
};
